import { createBrowserRouter, RouterProvider } from 'react-router';
import { routes } from '~/shared/constants/routes';
import Pages from '~/pages';
import { BaseLayout } from './components';
import { AppLayout, AppLoader } from './components/BaseLayout/components';

const router = createBrowserRouter([
    {
        element: <BaseLayout />,
        children: [
            {
                path: routes.auth,
                element: <Pages.Authentication />,
            },
            {
                path: routes.recover,
                element: <Pages.Recover />,
            },
            {
                path: routes.app,
                element: <AppLayout withHavbar />,
                children: [
                    {
                        index: true,
                        element: <AppLoader />,
                    },
                    {
                        path: routes.payin,
                        element: <Pages.Payin />,
                    },
                    {
                        path: routes['payin-order'],
                        element: <Pages.PayinOrder />,
                    },
                    {
                        path: routes.payout,
                        element: <Pages.Payout />,
                    },
                    {
                        path: routes['payout-order'],
                        element: <Pages.PayoutOrder />,
                    },

                    {
                        path: routes.tickets,
                        element: <Pages.Tickets />,
                    },
                    {
                        path: routes.traders,
                        element: <Pages.Traders />,
                    },
                    {
                        path: routes['payout-trader'],
                        element: <Pages.PayoutTrader />,
                    },
                    {
                        path: routes.cascades,
                        element: <Pages.Cascades />,
                    },
                    {
                        path: routes['payout-cascade'],
                        element: <Pages.PayoutCascade />,
                    },
                    {
                        path: routes['payout-cascade-group'],
                        element: <Pages.PayoutCascadeGroup />,
                    },
                    {
                        path: routes['payout-cascade-template'],
                        element: <Pages.PayoutCascadeTemplate />,
                    },
                    {
                        path: routes.settings,
                        element: <Pages.Settings />,
                    },
                    {
                        path: routes['privacy-policy'],
                        element: <Pages.PrivacyPolicy />,
                    },
                ],
            },
        ],
    },
]);

export const Router = () => {
    return <RouterProvider router={router} />;
};
